<template>
    <div class="external_detail-container">
        <div class="external_detail-content">
            <div>
                <span class="external_detail-label required-field">标题</span>
                <a-input v-model="externalInfo.title" placeholder="请输入标题" />
            </div>
            <div>
                <span class="external_detail-label required-field">链接</span>
                <a-input v-model="externalInfo.url" placeholder="请输入链接" />
            </div>
            <div>
                <span class="external_detail-label">说明内容</span>
                <a-textarea v-model="externalInfo.description" placeholder="请输入主题说明，最多2000字" :auto-size="{ minRows: 5 }"
                    :maxLength="2000" style="resize: none" />
            </div>
            <div>
                <span class="external_detail-label">页面预览</span>
                <iframe marginwidth=0 marginheight=0 :src="externalInfo.url" frameborder=no width=100%
                    height=500></iframe>
            </div>
            <div class="external_detail-operation">
                <a-button class="external_detail-operation_cancel" @click="cancelHandle">取消</a-button>
                <a-button class="external_detail-operation_submit" type="primary" @click="submitHandle">提交</a-button>
            </div>
        </div>

    </div>
</template>
  
<script>
import ExternalService from "@/api/externalService";
import { mapGetters } from "vuex";

export default {
    name: "externalDetail",
    data() {
        return {
            externalInfo: {
                title: undefined,
                url: undefined,
                description: undefined,
            },
        };
    },
    computed: {
        ...mapGetters(["schoolInfo"]),
    },

    created() {
        this.initHandle();
    },

    methods: {
        initHandle() {
            if (this.$route.query.id) {
                this.getExternalInfo();
            }
        },

        getExternalInfo() {
            this.loading = true;
            ExternalService.getExternalService({ id: this.$route.query.id }).then(res => {
                this.loading = false;
                this.externalInfo = res;
            }).catch(() => {
                this.loading = false;
            })
        },

        cancelHandle() {
            this.$router.replace({ name: "external" });
        },

        submitHandle() {
            const { id, title, description, url } = this.externalInfo;
            if (!title || !title.trim().length) {
                this.$message.warning("标题名称不能为空");
                return;
            }
            if (!url || !url.trim().length) {
                this.$message.warning("链接不能为空");
                return;
            }
            const params = { url: url.trim(), title: title.trim(), school_id: this.schoolInfo.id };
            if (description) {
                params.description = description.trim();
            }
            this.loading = true;
            if (id) {
                ExternalService.updateExternalService({ id, ...params }).then(() => {
                    this.$message.success("更新成功");
                    this.$router.replace({ name: "external" });
                }).catch(() => {
                    this.$message.error("更新失败，请检查后重试");
                    this.loading = false;
                });
            } else {
                ExternalService.createExternalService(params).then(() => {
                    this.$message.success("新建成功");
                    this.$router.replace({ name: "external" });
                    this.loading = false;
                }).catch(() => {
                    this.$message.error("新建失败，请检查后重试");
                    this.loading = false;
                });
            }
        },
    },
};
</script>
  
<style lang="less" scoped>
.external_detail {
    &-container {
        margin-top: 25px;
        margin-right: 100px;
        padding: 5px 64px 45px 45px;
        background-color: #ffffff;
    }


    &-label {
        display: block;
        height: 20px;
        margin: 22px 0 14px;
        font-size: 14px;
        color: #343c6a;
    }

    &-input {
        width: 360px;
        height: 32px;
        border-radius: 4px;
        border-color: #d5d5d5;
    }

    &-des {
        max-width: 700px;
        width: calc(100% - 30px);
    }

    &-operation {
        margin-top: 50px;
        text-align: center;

        &_cancel {
            width: 120px;
            margin-right: 30px;
        }

        &_submit {
            width: 120px;
        }
    }
}
</style>
